import earcut from "earcut";
import { Matrix4, Vector2, Vector3 } from "three";

export function CalculateMousePosition(
  e: { clientX: number; clientY: number },
  canvas: HTMLCanvasElement
): Vector2 {
  const box = canvas.getBoundingClientRect();
  const d = canvas.ownerDocument.documentElement;

  let _screenOffset = new Vector2();
  let _mousePosition = new Vector2();
  let _normalizedMousePosition = new Vector2();
  const scrollTop = Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  );
  const scrollLeft = Math.max(
    window.pageXOffset,
    document.documentElement.scrollLeft,
    document.body.scrollLeft
  );
  _screenOffset.setX(box.left + window.pageXOffset - d.clientLeft - scrollLeft);
  _screenOffset.setY(box.top + window.pageYOffset - d.clientTop - scrollTop);

  [_mousePosition.x, _mousePosition.y] = [
    e.clientX - _screenOffset.x,
    e.clientY - _screenOffset.y,
  ];
  const boundingClientRect = canvas.getBoundingClientRect();
  _normalizedMousePosition.x =
    2 * (_mousePosition.x / boundingClientRect.width) - 1;
  _normalizedMousePosition.y =
    -2 * (_mousePosition.y / boundingClientRect.height) + 1;

  return _normalizedMousePosition;
}

export function triangulateXY(points: Vector3[]): number[] {
  const vertexArray = [];
  for (const p of points) {
    // vertexArray.push(...p.toArray());
    vertexArray.push(p.x, p.y);
  }
  return earcut(vertexArray, [], 2);
}

export function debounce(func: (args: any) => void, timeout = 300) {
  let timer: any;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(args);
    }, timeout);
  };
}

export function rtkFixMatrixToThree(rtkMatrix: any, offset: Vector3): Matrix4 {
  /* prettier-ignore */
  const convertMatrix = [
  // Translate by offset
  new Matrix4().makeTranslation(
    offset.x, offset.y, offset.z
  ),
  // Convert xyz to x-zy
  new Matrix4().set(
    1, 0, 0, 0,
    0, 0, -1, 0,
    0, 1, 0, 0,
    0, 0, 0, 1
  )].reduce((acc, m) => {
    return acc.multiply(m);
  }, new Matrix4().identity());

  convertMatrix.multiply(new Matrix4().fromArray(rtkMatrix).transpose());
  return convertMatrix;
}
